<template>
    <p v-if="showTitle" class="card-title">{{ activity.libelle }}</p>
    <ul class="list-group list-group-flush">
      <li v-if="activity.natureAnimation" class="natureAnimation list-group-item fw-bold">
        <span v-text="activity.natureAnimation"/>
      </li>
      <li v-if="activity.debutActivite" class="dates list-group-item fw-bold">
        <span v-text="activity.debutActivite"/>
        <span v-if="activity.finActivite">&nbsp;{{ activity?.catalogueTraduction?.formPeriodesAu || $t('form.periodes.au') }}&nbsp;{{ activity.finActivite }}</span>
      </li>
      <li v-if="activity.publics?.length > 0 || activity.mobilite || activity.autonomie || activity.rythme"
          class="publics list-group-item fw-bold">
        <template v-if="activity.publics?.length > 0">
            <div v-for="(pub, index) in activity.publics"
                  :key="index" class="mb-2">{{ pub["nom"] + (index !== activity.publics.length - 1 ? ', ' : '') }}</div>
        </template>
        <div v-if="activity.mobilite" class="mobilite mb-2">{{ activity.mobilite }}</div>
        <div v-if="activity.autonomie" class="autonomie">{{ activity.autonomie }}</div>
        <div v-if="activity.rythme" class="rythme">{{ activity.rythme }}</div>
      </li>
      <li v-if="activity.lieuActivite" class="lieu list-group-item fw-bold">
        <a v-if="infosLieu" href="#" @click.prevent="goToPageArea(infosLieu)">{{ activity.lieuActivite.libelle }}</a>
        <span v-else>{{ activity.lieuActivite.libelle }}</span>
      </li>
      <li v-if="activity.embarquementsActivite?.length > 0" class="embarquements list-group-item">
        <strong>{{ activity?.catalogueTraduction?.activityDeparts || $t('activity.departs') }}&nbsp;:&nbsp;</strong>
        <ul class="no-bullets">
          <li v-for="(embarquement, index) in activity.embarquementsActivite" :key="embarquement.id">
            {{ embarquement.libelle }}
            <template v-if="index < (activity.embarquementsActivite.length - 1)">,&nbsp;</template>
          </li>
        </ul>
      </li>
      <li v-if="activity.organisateurActivite" class="organisateur list-group-item">
        <a v-if="infosOrga" href="#" @click.prevent="goToPageArea(infosOrga)">{{ activity.organisateurActivite }}</a>
        <span v-else>{{ activity.organisateurActivite }}</span>
      </li>
      <li v-if="(activity.prixBaseActivite && activity.prixBaseActivite > 0) || (activity.periodes && activity.periodes.length > 0 && activity.periodes[0].specifique)"
          class="prix list-group-item">
        <strong>{{ activity?.catalogueTraduction?.activityPrix || $t('activity.prix') }}&nbsp;:&nbsp;</strong>
        <span v-if="activity.prixBaseActivite && activity.prixBaseActivite > 0"
              class="base fw-bold badge badge-lg bg-secondary">{{ formatPrice(activity.prixBaseActivite) }}<small>&nbsp;€</small></span>
        <span v-else-if="activity.periodes && activity.periodes.length > 0"
              class="base fw-bold badge badge-lg bg-secondary">{{ formatPrice(activity.periodes[0].specifique) }}<small>&nbsp;€&nbsp;/&nbsp;{{
            $t(getLibelleForPrice)
          }}</small></span>
      </li>
      <li v-if="activity.reductionMC" class="mc list-group-item">
        <strong>{{ activity?.catalogueTraduction?.activityReductionMC || $t('activity.reductionMC') }}&nbsp;<span :title="activity?.catalogueTraduction?.activityToolTipReductionMC || $t('activity.toolTipReductionMC')"
                                                            class="bi-info-circle"
                                                            data-bs-placement="top"
                                                            data-bs-toggle="tooltip"></span>&nbsp;:&nbsp;</strong>
        <span
            v-if="activity.periodes && activity.periodes.length > 0 && activity.periodes[0].specifique && activity.typeTarifMC === constants.inscription.PRIX_PAR_JOUR"
            class="base fw-bold badge badge-lg bg-success">{{ formatPrice(activity.reductionMC, true) }}<small>&nbsp;€&nbsp;/&nbsp;{{
            activity?.catalogueTraduction?.activityPrixJour || $t('activity.prixJour')
          }}</small></span>
        <span
            v-else-if="activity.periodes && activity.periodes.length > 0 && activity.periodes[0].specifique && activity.typeTarifMC === constants.inscription.PRIX_PAR_PERIODE"
            class="base fw-bold badge badge-lg bg-success">{{ formatPrice(activity.reductionMC, true) }}<small>&nbsp;€&nbsp;/&nbsp;{{
            activity?.catalogueTraduction?.activityPrixSemaine || $t('activity.prixSemaine')
          }}</small></span>
        <span v-else class="fw-bold badge bg-success">{{
            formatPrice(activity.reductionMC, true)
          }}<small>&nbsp;€</small></span>
      </li>
      <li v-if="activity.reductionBIM" class="bim list-group-item">
        <strong>{{ activity?.catalogueTraduction?.activityReductionBIM || $t('activity.reductionBIM') }}&nbsp;<span :title="activity?.catalogueTraduction?.activityToolTipReductionBim || $t('activity.toolTipReductionBIM')"
                                                             class="bi-info-circle"
                                                             data-bs-placement="top"
                                                             data-bs-toggle="tooltip"></span>&nbsp;:&nbsp;</strong>
        <span
            v-if="activity.periodes && activity.periodes.length > 0 && activity.periodes[0].specifique && activity.typeTarifBIM === constants.inscription.PRIX_PAR_JOUR"
            class="base fw-bold badge badge-lg bg-success">{{ formatPrice(activity.reductionBIM, true) }}<small>&nbsp;€&nbsp;/&nbsp;{{
            activity?.catalogueTraduction?.activityPrixJour || $t('activity.prixJour')
          }}</small></span>
        <span
            v-else-if="activity.periodes && activity.periodes.length > 0 && activity.periodes[0].specifique && activity.typeTarifBIM === constants.inscription.PRIX_PAR_PERIODE"
            class="base fw-bold badge badge-lg bg-success">{{ formatPrice(activity.reductionBIM, true) }}<small>&nbsp;€&nbsp;/&nbsp;{{
            activity?.catalogueTraduction?.activityPrixSemaine || $t('activity.prixSemaine')
          }}</small></span>
        <span v-else class="fw-bold badge bg-success">{{
            formatPrice(activity.reductionBIM, true)
          }}<small>&nbsp;€</small></span>
      </li>
    </ul>
</template>

<script>
import {useStore} from "vuex";
import {ref} from "vue";
import {formatPrice, goToPageArea} from "@/utils";
import constants from "@/constants";

export default {
  name: "ActivityInfos",
  props: ['activity', 'showTitle', 'infosLieu', 'infosOrga', 'catalogueTraduction'],
  setup() {
    const store = useStore();
    const booking = ref(store.getters.getBooking);

    return {booking, formatPrice, constants, goToPageArea};
  },
  computed: {
    getLibelleForPrice() {
      if (this.activity.periodes[0].nbJours < 4)
        return this.activity?.catalogueTraduction?.activityPrixJour || 'jour';
      else if (this.activity.periodes[0].nbJours >= 4 && this.activity.periodes[0].nbJours <= 7)
        return this.activity?.catalogueTraduction?.activityPrixSemaine || 'semaine';
      else
        return this.activity?.catalogueTraduction?.activityPrixQuinzaine || 'quinzaine';
    }
  }
}
</script>

<style scoped>
ul .no-bullets {
  list-style-type: none;
}
</style>
